import React from 'react';
import UsersStyles from './Users.module.css';

const formatPromptTime = (createdAt) => {
	if (!createdAt) return '';
	const numericValue = Number(createdAt);
	const dateValue = Number.isFinite(numericValue) ? new Date(numericValue * 1000) : new Date(createdAt);
	if (Number.isNaN(dateValue.getTime())) return '';
	try {
		return new Intl.DateTimeFormat(undefined, {
			month: 'short',
			day: 'numeric',
			year: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
		}).format(dateValue);
	} catch (error) {
		return '';
	}
};

const PromptHistoryModal = ({ data }) => {
	const {
		promptHistoryModalStatus,
		promptHistoryRows,
		promptHistoryLoading,
		promptHistoryError,
		promptHistorySearchUser,
		setPromptHistorySearchUser,
		canSearchPromptHistory,
		handleSearchPromptHistory,
		closePromptHistoryModal,
	} = data;

	if (!promptHistoryModalStatus.status) {
		return null;
	}

	return (
		<div className={UsersStyles.promptHistoryOverlay} role='dialog' aria-modal='true' aria-labelledby='prompt-history-title'>
			<div className={UsersStyles.promptHistoryModal}>
				<div className={UsersStyles.promptHistoryHeader}>
					<div>
						<h3 id='prompt-history-title'>AI prompt history</h3>
						<p>
							{promptHistoryModalStatus.username}
							{promptHistoryModalStatus.company ? ` / ${promptHistoryModalStatus.company}` : ''}
						</p>
					</div>
					<button type='button' onClick={closePromptHistoryModal}>
						Close
					</button>
				</div>

				{canSearchPromptHistory && (
					<form className={UsersStyles.promptHistorySearch} onSubmit={handleSearchPromptHistory}>
						<input
							type='search'
							value={promptHistorySearchUser}
							onChange={(event) => setPromptHistorySearchUser(event.target.value)}
							placeholder='Search by username'
							aria-label='Search AI prompts by username'
						/>
						<button type='submit'>Search</button>
					</form>
				)}

				<div className={UsersStyles.promptHistoryBody}>
					{promptHistoryLoading ? (
						<div className={UsersStyles.promptHistoryEmpty}>Loading prompts...</div>
					) : promptHistoryError ? (
						<div className={UsersStyles.promptHistoryError}>{promptHistoryError}</div>
					) : promptHistoryRows.length > 0 ? (
						promptHistoryRows.map((item) => (
							<article key={item.id} className={UsersStyles.promptHistoryItem}>
								<div className={UsersStyles.promptHistoryMeta}>
									<span>{formatPromptTime(item.created_at)}</span>
									<span>{item.username || 'unknown user'}</span>
									{item.company && <span>{item.company}</span>}
									<span>{item.prompt_type || 'general'}</span>
									{item.status && item.status !== 'completed' && <span>{item.status}</span>}
									{item.page && <span>{item.page}</span>}
								</div>
								<p className={UsersStyles.promptHistoryPrompt}>{item.prompt}</p>
								{item.response && <p className={UsersStyles.promptHistoryResponse}>{item.response}</p>}
							</article>
						))
					) : (
						<div className={UsersStyles.promptHistoryEmpty}>No AI prompts found for this user.</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default PromptHistoryModal;
